import { useEffect, useState } from 'react';
import {
  FAVORITES_CHANGED_EVENT,
  loadFavorites,
  saveFavorites,
} from 'utils/favorites';

export function useFavorites() {
  const [favorites, setFavorites] = useState(loadFavorites);

  useEffect(() => {
    const sync = () => setFavorites(loadFavorites());
    window.addEventListener(FAVORITES_CHANGED_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(FAVORITES_CHANGED_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  const toggleFavorite = (route) => {
    const current = loadFavorites();
    saveFavorites(
      current.includes(route)
        ? current.filter((r) => r !== route)
        : [...current, route],
    );
  };

  return { favorites, toggleFavorite };
}
